<template>
  <md-card class="card-content">
    <md-card-header class="md-card-header-text md-card-header-green">
      <div class="card-text">
        <h4 class="title text-lg">
          {{ $t("attendance_report.overview.block_top_present") }}
        </h4>
      </div>
    </md-card-header>
    <md-card-content>
      <yv-index
        :path="path"
        :formSearch="formSearch"
        :columns="columns"
        :inlineSearchAction="true"
        :paginationCfg="{
          perPage: searchByTop.value,
          hidePerPageOptions: true,
          hidePaging: true
        }"
        :sortData="{}"
        :hideAction="true"
        :hideBulkAction="true"
        :tableDesc="tableDesc"
        :hasArrayRes="true"
        :formatTableData="formatTableData"
        :hideNoNumber="true"
        ref="topPresentTable"
      >
        <template #search-actions>
          <md-button
            native-type="submit"
            @click="search"
            class="md-info md-round"
            ref="searchBtn"
            >{{ $t("common.report") }}
          </md-button>
        </template>
      </yv-index>
    </md-card-content>
  </md-card>
</template>

<script>
import YvIndex from "@/components/Base/YvIndex.vue";
import { STUDENT_TABLE as stdTableUtils } from "@/pages/Report/utils";
import {
  filterOptions as filterOptionsMixin,
  baseFormSearch as baseFormSearchMixin
} from "../mixins";
import { service_paths } from "@/constants/Services";
import { Message } from "@/helpers/utils";

export default {
  components: { YvIndex },
  mixins: [filterOptionsMixin, baseFormSearchMixin],
  inject: ["filteringOptions"],
  data() {
    return {
      path: `${service_paths.reports}/attendance/present-top`,
      searchByTop: {
        label: this.$t(
          "attendance_report.overview.top_present_table_filtering_by_top"
        ),
        name: "limit",
        value: 10,
        type: "select",
        options: [5, 10, 20, 50].map(value => ({ id: value, name: value }))
      },
      columns: {
        student_info: "common.student",
        student_code: "common.student_code",
        attendance_percentage:
          "attendance_report.overview.top_present_table_col_attendance_percentage",
        current_status:
          "attendance_report.overview.top_present_table_col_status"
      },
      tableDesc: ""
    };
  },
  methods: {
    async search() {
      if (this.hasNoTerm) {
        Message.error("Please select term to view report");
        return;
      }
      await this.fetchTopPresentStudents();
      this.setTableDesc();
    },
    async fetchTopPresentStudents(shouldShowLoading = true) {
      return this.$refs.topPresentTable.getTableData(shouldShowLoading);
    },
    formatTableData(users) {
      return users
        .map(userInfo => {
          const student = userInfo.user.user_no_sql;

          if (!student) return null;

          return {
            student_info: this.generateInfoColHTML(student),
            attendance_percentage: userInfo.percent
              ? Number(userInfo.percent).toFixed(2)
              : "",
            student_code: student.student_code,
            current_status: stdTableUtils.generateStatusColHTML(
              student.study_status
            )
          };
        })
        .filter(Boolean);
    },
    generateInfoColHTML(student) {
      const avatarURL = student.avatar || "/img/avt_placeholder.jpg";
      return `<div class="flex items-center">
        <img src="${avatarURL}" class="object-cover rounded-full w-[42px] h-[42px]">
        <p class="font-normal ml-2">${student.full_name}</p>
      </div>`;
    },
    setTableDesc() {
      const filteringTop = this.searchByTop.value;
      const termName = this.formSearch[0].options.find(
        term => term.id === this.formSearch[0].value
      )?.name;
      const classesDesc = this.getClassesDesc();

      this.tableDesc = `Top ${filteringTop} attendance for: ${termName}, ${classesDesc}`;
    },
    getClassesDesc() {
      const filteringClasses = this.formSearch[1];

      if (filteringClasses.value.length === filteringClasses.options.length) {
        return "All classes";
      }

      const classesQuantity = filteringClasses.value.length;

      if (!classesQuantity) {
        return "";
      }

      if (classesQuantity === 1) {
        const className = filteringClasses.options.find(
          classObj => classObj.id === filteringClasses.value[0]
        ).name;

        return className;
      }

      return filteringClasses.value.length + "";
    },

    initalizeTable() {
      if (this.hasNoTerm) return;
      this.search();
    }
  },
  computed: {
    formSearch() {
      return [...this.baseFormSearch, this.searchByTop];
    },
    termName() {
      const termId = this.formSearch[0].value;
      return this.formSearch[0].options.find(term => termId === term.id).name;
    },
    hasNoTerm() {
      return !this.formSearch[0].value;
    }
  },
  watch: {
    defaultClasses() {
      this.initalizeTable();
    }
  }
};
</script>

<style lang="scss" scoped></style>
